/*
 * @Author: Teemo Ding
 * @Date: 2021-09-03 11:16:20
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-09-18 13:09:13
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelDomain/Components/StatusTag/index.tsx
 */
import React from 'react';
import { EnumStatus } from '@/src/types/common/domain';
import css from './css.module.less';

const StatusTag = ({ status }) => {
  const tagColor = {
    [EnumStatus.Connected]: { color: '#52C41A', backgroundColor: '#F6FFED' },
    [EnumStatus.Verified]: { color: '#52C41A', backgroundColor: '#F6FFED' },
    [EnumStatus.ActionRequired]: {
      color: '#FF6158',
      backgroundColor: '#FFF1F0',
    },
    [EnumStatus.Pending]: { color: '#1B93C5', backgroundColor: '#F4FCFF' },
    [EnumStatus.Disconnected]: { color: '#B9BCBF', backgroundColor: '#F4F5F7' },
  };

  return (
    <div
      className={css.statusTag}
      style={{
        ...(tagColor[status] || {
          color: '#B9BCBF',
          backgroundColor: '#F4F5F7',
        }),
        border: `1px solid ${tagColor[status]?.color || '#B9BCBF'}`,
      }}>
      {status}
    </div>
  );
};

export default StatusTag;
